// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface ArrangeZToAIconSignature {
  Element: SVGSVGElement;
}

export const ArrangeZToAIcon: TOC<ArrangeZToAIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M20.832 3.555L17.869 8H21V10H16C15.631 10 15.292 9.797 15.118 9.471C14.944 9.146 14.963 8.752 15.168 8.445L18.131 4H15V2H20C20.369 2 20.708 2.203 20.882 2.529C21.056 2.854 21.037 3.248 20.832 3.555ZM9 3V17.586L11.293 15.293L12.707 16.707L8 21.414L3.293 16.707L4.707 15.293L7 17.586V3H9ZM20 14H16C15.448 14 15 14.448 15 15V22H17V20H19V22H21V15C21 14.447 20.552 14 20 14ZM17 16V18H19V16H17Z"/>
</svg>
</template>;